exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qn-upload[data-v-7ec3b6ec] .el-upload-list__item.is-warning {\n  border-color: #F7BA2A;\n}\n.qn-upload[data-v-7ec3b6ec] .el-upload-list__item.is-fail {\n  border-color: #FF4949;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ec3b6ec","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/QnUpload-1.0.0/index.vue
// module id = WUGP
// module chunks = 212